module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_pp1_8004.1dee6bb7.png";